import React, {useLayoutEffect, useState} from 'react';
import '../assets/App.scss';
import Grid from '@material-ui/core/Grid';
import Home from "./Home";
import {BrowserRouter as Router} from "react-router-dom";
import Stores from "../contexts/stores";
import TopAppBar from "../components/TopAppBar";
import FbProvider from "../contexts/FbProvider";
import {GlobalProviders} from "../contexts/GlobalProviders";
import {ApontamentoProvider} from "../contexts/ApontamentoProvider";
import {makeStyles} from "@material-ui/core";
import Player from "../components/Player";
import {DialogProvider} from '../contexts/DialogContext';
import SideBars from '../components/SideBars';
import {Alert} from '@material-ui/lab';
import Button from '@material-ui/core/Button';
import axios from 'axios';
import IconButton from '@material-ui/core/IconButton';
import {IconFechar} from '../components/icons/MateraIcons';
import {version} from '../../package.json'


// let ipcRenderer = window.require ? window.require('electron').ipcRenderer : undefined;

const useStyle = makeStyles(theme => ({
    app: {
        flex: 1
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    },
    bottom: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        maxHeight: 120,
        minHeight: 120,
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
            alignSelf: 'flex-end',
            width: '100%',
            maxHeight: 80,
            height: 80,
            minHeight: 80
        },
        [theme.breakpoints.down('xs')]: {
            position: 'relative',

        }
    },
}));

function App() {
    const classes = useStyle();
    const [menu, setMenu] = useState(false);
    const [calendar, setCalendar] = useState(false);
    const [hasUpdate, setHasUpdate] = useState(false);

    /*const maximize = () => {
        if (ipcRenderer)
            ipcRenderer.send('maximize');
    };*/


    useLayoutEffect(() => {
        (async () => {
            let response = await axios.get(`${process.env.PUBLIC_URL}/manifest.json?time=${Date.now()}`);
            if (response?.data.version && response?.data.version !== version)
                setTimeout(() =>
                        setHasUpdate(true)
                    , 5000)
        })()
    }, [])


    return (
        <Router>
            <GlobalProviders>
                <Grid className={classes.container}>
                    <Grid container id={'home-container'} direction={'column'} justifyContent={'center'}
                          className={classes.app}>
                        <FbProvider data={Stores.data}>
                            <DialogProvider>
                                <ApontamentoProvider menuCalendar={[calendar, setCalendar]} menu={[menu, setMenu]}>
                                    {
                                        hasUpdate && <Alert severity="success"
                                                            action={
                                                                <>
                                                                    <Button color="inherit" size="small"
                                                                            onClick={() => window.location.reload()}>
                                                                        Atualizar
                                                                    </Button>
                                                                    <IconButton
                                                                        aria-label="close"
                                                                        color="inherit"
                                                                        size="small"
                                                                        onClick={() => {
                                                                            setHasUpdate(false);
                                                                        }}
                                                                    >
                                                                        <IconFechar size={16}/>
                                                                    </IconButton>
                                                                </>
                                                            }>Há uma nova atualização!</Alert>
                                    }
                                    <TopAppBar menu={[menu, setMenu]}/>
                                    <Home/>
                                    <SideBars calendar={[calendar, setCalendar]} menu={[menu, setMenu]}/>
                                    <Grid item sm={12} xs={12} className={classes.bottom}>
                                        <Player calendar={calendar} setCalendar={setCalendar}/>
                                    </Grid>
                                </ApontamentoProvider>
                            </DialogProvider>
                        </FbProvider>
                    </Grid>
                </Grid>
            </GlobalProviders>
        </Router>
    )

}

export default App;
